/**
 * 外殼版本探針（UI v2 步 9：由 `MePage` 抽出共用）
 *   讀返而家載入緊嘅 bundle 檔名（例：`index-vvI6Y5XE.js`）—— 出事時一句就知版本。純讀。
 */
export function currentBundleName(): string {
  if (typeof document === 'undefined') return '';
  const src = Array.from(document.querySelectorAll('script[src]'))
    .map((el) => (el as HTMLScriptElement).src)
    .find((s) => /\/assets\/index-.*\.js(\?|$)/.test(s));
  return src ? (src.split('/').pop() ?? '') : '';
}
